import React, { useEffect, useState, memo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import $ from 'jquery';
import classnames from 'classnames';

import SubMenuItems from './SubMenuItems';
import SubMenuVariavel from './SubMenuVariavel';
import SubMenuTag from './SubMenuTag';
import SubMenuSettings from './SubMenuSettings';
import SubMenuAudioUpload from './SubMenuAudioUpload';
import SaveTemplateBotButton from './Components/SaveTemplateBotButton';

import iconTag from '../../../assets/images/icon_tag.svg';

import { UserActions } from '../../../store/actions/users';
import './style.css';

const MenuLeft = ({ showLeftMenu, show, botId, user, bot }) => {
  const [draggingType, setDraggingType] = useState(null);
  const [isBlocos, setIsBlocos] = useState('chat');

  useEffect(() => {
    $('[data-toggle="tooltip"]').tooltip();
  }, []);

  const handleDragStart = (e, type) => {
    console.log('dragstart', e, type);
    setDraggingType(type);
    e.dataTransfer.setData('text/plain', type);
  };

  const handleDragEnd = (e) => {
    console.log('handleDragEnd', e);
    setDraggingType(null);
  };

  const handleClickMenu = (menu) => {
    showLeftMenu(menu);
  };

  const clickTypeBlocos = (type) => {
    setIsBlocos(type);
  };

  const renderSaveTemplateButton = () => {
    if (user?.selectedCompany?.claim?.name !== 'Root') {
      return false;
    }
    return <SaveTemplateBotButton user={user} show={show} />;
  };

  return (
    <>
      <nav className="menu-criador jc-bet">
        <div>
          <div
            className={
              user?.selectedCompany?.claim?.name !== 'Viewer'
                ? `menu-criador-item ${
                    show === 'criador' && 'menu-criador-ativo'
                  }`
                : `menu-criador-item op-user-menuleft ${
                    show === 'criador' && 'menu-criador-ativo'
                  }`
            }
          >
            <a
              href="#/"
              onClick={() =>
                handleClickMenu(
                  user?.selectedCompany?.claim?.name !== 'Viewer'
                    ? 'criador'
                    : ''
                )
              }
            >
              <img
                className="img-menu-esquerda"
                alt="Novo bloco"
                src="/assets/images/icons/icon_new_box.svg"
              />
            </a>
          </div>

          {bot?.type === 'voice' && (
            <>
              <div
                className={classnames('menu-criador-item', {
                  'menu-criador-ativo': show === 'settings',
                })}
              >
                <a
                  href="#/"
                  onClick={() =>
                    handleClickMenu(
                      user?.selectedCompany?.claim?.name !== 'Viewer'
                        ? 'settings'
                        : ''
                    )
                  }
                >
                  <img
                    className="img-menu-esquerda"
                    alt="Configurações"
                    src="/assets/images/icons/icon_bot_config_on.svg"
                  />
                </a>
              </div>
              <div
                className={classnames('menu-criador-item', {
                  'menu-criador-ativo': show === 'audioUpload',
                })}
              >
                <a
                  href="#/"
                  onClick={() =>
                    handleClickMenu(
                      user?.selectedCompany?.claim?.name !== 'Viewer'
                        ? 'audioUpload'
                        : ''
                    )
                  }
                >
                  <img
                    style={{ width: 18 }}
                    alt="Configurações"
                    src="/assets/images/icons/icon_file_audio_regular_edit.svg"
                  />
                </a>
              </div>
            </>
          )}

          {bot?.type !== 'voice' && (
            <>
              <div
                className={
                  user?.selectedCompany?.claim?.name !== 'Viewer'
                    ? `menu-criador-item ${
                        show === 'variavel' && 'menu-criador-ativo'
                      }`
                    : `menu-criador-item op-user-menuleft ${
                        show === 'variavel' && 'menu-criador-ativo'
                      }`
                }
              >
                <a
                  href="#/"
                  onClick={() =>
                    handleClickMenu(
                      user?.selectedCompany?.claim?.name !== 'Viewer'
                        ? 'variavel'
                        : ''
                    )
                  }
                >
                  <img
                    className="img-menu-esquerda"
                    alt="Variável"
                    src="/assets/images/icons/icon_resposta_variavel.svg"
                  />
                </a>
              </div>

              <div
                className={
                  user?.selectedCompany?.claim?.name !== 'Viewer'
                    ? `menu-criador-item ${
                        show === 'tag' && 'menu-criador-ativo'
                      }`
                    : `menu-criador-item op-user-menuleft ${
                        show === 'tag' && 'menu-criador-ativo'
                      }`
                }
              >
                <a
                  href="#/"
                  onClick={() =>
                    handleClickMenu(
                      user?.selectedCompany?.claim?.name !== 'Viewer'
                        ? 'tag'
                        : ''
                    )
                  }
                >
                  <img className="img-menu-esquerda" alt="Tag" src={iconTag} />
                </a>
              </div>
            </>
          )}

          {bot?.type !== 'voice' && (
            <>
              <div className="divider" />
              {renderSaveTemplateButton()}
            </>
          )}
        </div>
      </nav>

      <SubMenuItems
        handleDragStart={handleDragStart}
        handleDragEnd={handleDragEnd}
        draggingType={draggingType}
        isActive={show === 'criador'}
        isBlocos={isBlocos}
        clickTypeBlocos={clickTypeBlocos}
        botType={bot?.type}
      />

      <SubMenuVariavel isActive={show === 'variavel'} botId={botId} />
      <SubMenuTag isActive={show === 'tag'} botId={botId} />

      {bot?.type === 'voice' && (
        <>
          <SubMenuSettings
            isActive={show === 'settings'}
            bot={bot}
            onClickOutside={() => showLeftMenu(null)}
          />

          <SubMenuAudioUpload isActive={show === 'audioUpload'} botId={botId} />
        </>
      )}
    </>
  );
};
const mapStateToProps = (state) => ({
  user: state.users.signedUser,
  bot: state.bots.bot,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...UserActions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(memo(MenuLeft));
